export default "__VITE_ASSET__3254749a__"